import axios from 'axios';

// TODO: Replace with environment variable if needed
// const API_URL = 'http://localhost:5000';

export async function login(username: string, password: string) {
  const response = await axios.post('/api/users/login', { username, password });
  return response.data;
}

export const setAuthToken = (token: string | null) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    localStorage.setItem('token', token);
  } else {
    delete axios.defaults.headers.common['Authorization'];
    localStorage.removeItem('token');
  }
}; 